import React, { ReactElement } from 'react'

function Step2Tooltip(): ReactElement {
  return (
    <div className="card cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        Nous sommes tenus par la réglementation de disposer de ces informations.
        Il s’agit d’informations strictement confidentielles qui seront soumises
        à la politique de protection des données personnelles en vigueur.
      </p>
    </div>
  )
}

export default Step2Tooltip
